/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ product: NonNullable<unknown> }} Great_Gray_Lemming_TrustInputs */

const en_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Cancel purchase`);
	return /** @type {LocalizedString} */ (`Cancel subscription`)
	
};

const id_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Batalkan pembelian`);
	return /** @type {LocalizedString} */ (`Batalkan langganan`)
	
};

const ms_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Batalkan pembelian`);
	return /** @type {LocalizedString} */ (`Batalkan langganan`)
	
};

const ca_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Cancel·la la compra`);
	return /** @type {LocalizedString} */ (`Cancel·lar la subscripció`)
	
};

const cs_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Zrušit nákup`);
	return /** @type {LocalizedString} */ (`Zrušit předplatné`)
	
};

const da_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Annuller køb`);
	return /** @type {LocalizedString} */ (`Opsig abonnement`)
	
};

const de_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Kauf stornieren`);
	return /** @type {LocalizedString} */ (`Abonnement kündigen`)
	
};

const et_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Tühista ost`);
	return /** @type {LocalizedString} */ (`Tühista tellimus`)
	
};

const es_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Cancelar compra`);
	return /** @type {LocalizedString} */ (`Cancelar la suscripción`)
	
};

const fr_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Annuler l’achat`);
	return /** @type {LocalizedString} */ (`Annuler l’abonnement`)
	
};

const hr_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Otkaži kupnju`);
	return /** @type {LocalizedString} */ (`Otkaži pretplatu`)
	
};

const it_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Annulla acquisto`);
	return /** @type {LocalizedString} */ (`Cancella abbonamento`)
	
};

const lv_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Atcelt pirkumu`);
	return /** @type {LocalizedString} */ (`Atcelt abonementu`)
	
};

const lt_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Atšaukti pirkimą`);
	return /** @type {LocalizedString} */ (`Atšaukti prenumeratą`)
	
};

const hu_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Vásárlás visszavonása`);
	return /** @type {LocalizedString} */ (`Előfizetés törlése`)
	
};

const nl_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Aankoop annuleren`);
	return /** @type {LocalizedString} */ (`Abonnement opzeggen`)
	
};

const nb_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Avbryt kjøp`);
	return /** @type {LocalizedString} */ (`Si opp abonnementet`)
	
};

const pl_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Anuluj zakup`);
	return /** @type {LocalizedString} */ (`Anuluj subskrypcję`)
	
};

const pt_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Cancelar compra`);
	return /** @type {LocalizedString} */ (`Cancelar assinatura`)
	
};

const ro_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Anulează achiziția`);
	return /** @type {LocalizedString} */ (`Anulează abonamentul`)
	
};

const sk_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Zrušiť nákup`);
	return /** @type {LocalizedString} */ (`Zrušiť predplatné`)
	
};

const sl_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Prekliči nakup`);
	return /** @type {LocalizedString} */ (`Prekličite naročnino`)
	
};

const fi_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Peruuta osto`);
	return /** @type {LocalizedString} */ (`Peruuta tilaus`)
	
};

const sv_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Avbryt köp`);
	return /** @type {LocalizedString} */ (`Avsluta prenumeration`)
	
};

const vi_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Hủy mua hàng`);
	return /** @type {LocalizedString} */ (`Hủy gói đăng ký`)
	
};

const tr_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Satın almayı iptal et`);
	return /** @type {LocalizedString} */ (`Aboneliği iptal et`)
	
};

const el_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Ακύρωση αγοράς`);
	return /** @type {LocalizedString} */ (`Ακύρωση συνδρομής`)
	
};

const bg_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Отказ на покупката`);
	return /** @type {LocalizedString} */ (`Отмяна на абонамента`)
	
};

const ru_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Отменить покупку`);
	return /** @type {LocalizedString} */ (`Отмена подписки`)
	
};

const sr_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Откажи куповину`);
	return /** @type {LocalizedString} */ (`Откажи претплату`)
	
};

const uk_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Скасувати покупку`);
	return /** @type {LocalizedString} */ (`Скасувати підписку`)
	
};

const ka_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`შეძენის გაუქმება`);
	return /** @type {LocalizedString} */ (`გამოწერის გაუქმება`)
	
};

const hi_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`खरीद रद्द करें`);
	return /** @type {LocalizedString} */ (`सब्सक्रिप्शन रद्द करें`)
	
};

const th_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`ยกเลิกการซื้อ`);
	return /** @type {LocalizedString} */ (`ยกเลิกการเป็นสมาชิก`)
	
};

const ko_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`구매 취소`);
	return /** @type {LocalizedString} */ (`구독 취소`)
	
};

const zh_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`取消订阅`)
};

const zh_tw_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`取消購買`);
	return /** @type {LocalizedString} */ (`取消訂閱`)
	
};

const ja_great_gray_lemming_trust = /** @type {(inputs: Great_Gray_Lemming_TrustInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`購入をキャンセル`);
	return /** @type {LocalizedString} */ (`サブスクリプションをキャンセル`)
	
};

/**
* | product | output |
* | --- | --- |
* | "origin" | "Cancel purchase" |
* | * | "Cancel subscription" |
*
* @param {Great_Gray_Lemming_TrustInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const great_gray_lemming_trust = /** @type {((inputs: Great_Gray_Lemming_TrustInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Great_Gray_Lemming_TrustInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_great_gray_lemming_trust(inputs)
	if (locale === "ms") return ms_great_gray_lemming_trust(inputs)
	if (locale === "ca") return ca_great_gray_lemming_trust(inputs)
	if (locale === "cs") return cs_great_gray_lemming_trust(inputs)
	if (locale === "da") return da_great_gray_lemming_trust(inputs)
	if (locale === "de") return de_great_gray_lemming_trust(inputs)
	if (locale === "et") return et_great_gray_lemming_trust(inputs)
	if (locale === "es") return es_great_gray_lemming_trust(inputs)
	if (locale === "fr") return fr_great_gray_lemming_trust(inputs)
	if (locale === "hr") return hr_great_gray_lemming_trust(inputs)
	if (locale === "it") return it_great_gray_lemming_trust(inputs)
	if (locale === "lv") return lv_great_gray_lemming_trust(inputs)
	if (locale === "lt") return lt_great_gray_lemming_trust(inputs)
	if (locale === "hu") return hu_great_gray_lemming_trust(inputs)
	if (locale === "nl") return nl_great_gray_lemming_trust(inputs)
	if (locale === "nb") return nb_great_gray_lemming_trust(inputs)
	if (locale === "pl") return pl_great_gray_lemming_trust(inputs)
	if (locale === "pt") return pt_great_gray_lemming_trust(inputs)
	if (locale === "ro") return ro_great_gray_lemming_trust(inputs)
	if (locale === "sk") return sk_great_gray_lemming_trust(inputs)
	if (locale === "sl") return sl_great_gray_lemming_trust(inputs)
	if (locale === "fi") return fi_great_gray_lemming_trust(inputs)
	if (locale === "sv") return sv_great_gray_lemming_trust(inputs)
	if (locale === "vi") return vi_great_gray_lemming_trust(inputs)
	if (locale === "tr") return tr_great_gray_lemming_trust(inputs)
	if (locale === "el") return el_great_gray_lemming_trust(inputs)
	if (locale === "bg") return bg_great_gray_lemming_trust(inputs)
	if (locale === "ru") return ru_great_gray_lemming_trust(inputs)
	if (locale === "sr") return sr_great_gray_lemming_trust(inputs)
	if (locale === "uk") return uk_great_gray_lemming_trust(inputs)
	if (locale === "ka") return ka_great_gray_lemming_trust(inputs)
	if (locale === "hi") return hi_great_gray_lemming_trust(inputs)
	if (locale === "th") return th_great_gray_lemming_trust(inputs)
	if (locale === "ko") return ko_great_gray_lemming_trust(inputs)
	if (locale === "zh") return zh_great_gray_lemming_trust(inputs)
	if (locale === "zh-tw") return zh_tw_great_gray_lemming_trust(inputs)
	if (locale === "ja") return ja_great_gray_lemming_trust(inputs)
	return en_great_gray_lemming_trust(inputs)
});